export class ServiceFieldOptionMessage {
  id: number
  active: boolean
  additionalCost: number
  displayOrder: number
  value: string

  constructor(id: number, active: boolean, additionalCost: number, displayOrder: number, value: string) {
    this.id = id
    this.active = active
    this.additionalCost = additionalCost
    this.displayOrder = displayOrder
    this.value = value
  }
}
  